import React, {Component} from 'react';
import {Route} from 'react-router-dom'
import ArticleSearch from '../../components/Dictionary/ArticleSearch';
import ArticleList from '../../components/Dictionary/ArticleList';
import Article from '../../components/Dictionary/Article';
import gql from 'graphql-tag';
import {graphql} from 'react-apollo';

import {Row, Col} from 'reactstrap';

class Dictionary extends Component {

  constructor(props) {
    super(props);
    this.state = {articlesList: [], filtredList: []};
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data.articles) {
      var articles = nextProps.data.articles;
      this.setState({articlesList: articles, filtredList: articles});
    }
  }

  handleSearch(event) {
    this.setState({filtredList: this.filterList(event)});
  }

  filterList(event) {
    return this.state.articlesList.filter(function (item) {
      return item.title.toLowerCase().search(
        event.target.value.toLowerCase()) !== -1;
    });
  }

  render() {
    return (
      <div className="animated fadeIn dictionary">
        <Row>
          <Col md="3">
            <ArticleSearch onChange={this.handleSearch}/>
            <ArticleList data={this.state.filtredList}/>
          </Col>
          <Col md="9">
            <Route path="/dictionary/:id" component={Article}/>
          </Col>
        </Row>
      </div>
    )
  }
}

const DictionariesListQuery = gql`
  query DictionariesListQuery {
    articles {
      id, title
    }
  }
`;

export default graphql(DictionariesListQuery, {
  options: {fetchPolicy: 'network-only'},
})(Dictionary);



// WEBPACK FOOTER //
// ./src/views/Dictionary/Dictionary.js